module.exports = __webpack_public_path__ + "img/loader.ac458663.svg";